if (!customElements.get('birthstone-addon')) {
  class BirthstoneAddon extends HTMLElement {
    constructor() {
      super();

      this.selectedItems = new Map();
      this.isInitialized = false;

      this.handleAdd = this.handleAdd.bind(this);
      this.handleRemove = this.handleRemove.bind(this);
      this.handleQuantityChange = this.handleQuantityChange.bind(this);
    }

    connectedCallback() {
      if (this.isInitialized) return;

      this.variantSelect = this.querySelector('[data-birthstone-variant]');
      this.quantityInput = this.querySelector('[data-birthstone-quantity]');
      this.addButton = this.querySelector('[data-birthstone-add]');
      this.selectionContainer = this.querySelector(
        '[data-birthstone-selection]'
      );
      this.selectionList = this.querySelector(
        '[data-birthstone-selection-list]'
      );
      this.emptyMessage = this.querySelector('[data-birthstone-empty]');
      this.statusMessage = this.querySelector('[data-birthstone-message]');

      if (
        !this.variantSelect ||
        !this.quantityInput ||
        !this.addButton ||
        !this.selectionContainer ||
        !this.selectionList
      ) {
        return;
      }

      this.addButton.addEventListener('click', this.handleAdd);
      this.selectionList.addEventListener('click', this.handleRemove);
      this.quantityInput.addEventListener(
        'change',
        this.handleQuantityChange
      );

      this.isInitialized = true;
      this.renderSelections();
    }

    disconnectedCallback() {
      if (!this.isInitialized) return;

      this.addButton.removeEventListener('click', this.handleAdd);
      this.selectionList.removeEventListener('click', this.handleRemove);
      this.quantityInput.removeEventListener(
        'change',
        this.handleQuantityChange
      );

      this.isInitialized = false;
    }

    handleQuantityChange() {
      let quantity = Number.parseInt(this.quantityInput.value, 10);

      if (!Number.isFinite(quantity) || quantity < 1) {
        quantity = 1;
      }

      if (quantity > 10) {
        quantity = 10;
      }

      this.quantityInput.value = quantity;
    }

    handleAdd() {
      const selectedOption =
        this.variantSelect.options[this.variantSelect.selectedIndex];

      if (!selectedOption || selectedOption.disabled) {
        this.showMessage(
          'Deze geboortesteen is momenteel niet beschikbaar.'
        );
        return;
      }

      this.handleQuantityChange();

      const variantId = selectedOption.value;
      const quantity = Number.parseInt(this.quantityInput.value, 10);
      const title =
        selectedOption.dataset.variantTitle || selectedOption.textContent.trim();
      const price = selectedOption.dataset.variantPrice || '';

      const existingItem = this.selectedItems.get(variantId);

      if (existingItem) {
        existingItem.quantity += quantity;
        this.selectedItems.set(variantId, existingItem);
      } else {
        this.selectedItems.set(variantId, {
          id: Number(variantId),
          title: title,
          price: price,
          quantity: quantity,
        });
      }

      this.quantityInput.value = 1;
      this.showMessage(`${title} is toegevoegd aan je selectie.`);
      this.renderSelections();
    }

    handleRemove(event) {
      const removeButton = event.target.closest(
        '[data-remove-birthstone]'
      );

      if (!removeButton) return;

      const variantId = removeButton.dataset.removeBirthstone;
      const removedItem = this.selectedItems.get(variantId);

      this.selectedItems.delete(variantId);

      if (removedItem) {
        this.showMessage(
          `${removedItem.title} is uit je selectie verwijderd.`
        );
      }

      this.renderSelections();
    }

    renderSelections() {
      const fragment = document.createDocumentFragment();

      this.selectedItems.forEach((item, variantId) => {
        const listItem = document.createElement('li');
        listItem.className = 'birthstone-addon__selection-item';

        const itemInformation = document.createElement('span');
        itemInformation.className = 'birthstone-addon__selection-name';
        itemInformation.textContent =
          `${item.title} × ${item.quantity}`;

        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'birthstone-addon__remove';
        removeButton.dataset.removeBirthstone = variantId;
        removeButton.textContent = 'Verwijderen';
        removeButton.setAttribute(
          'aria-label',
          `${item.title} uit de selectie verwijderen`
        );

        listItem.appendChild(itemInformation);
        listItem.appendChild(removeButton);
        fragment.appendChild(listItem);
      });

      this.selectionList.replaceChildren(fragment);

      const hasSelections = this.selectedItems.size > 0;

      this.selectionContainer.hidden = !hasSelections;

      if (this.emptyMessage) {
        this.emptyMessage.hidden = hasSelections;
      }

      this.dispatchEvent(
        new CustomEvent('birthstone:addons-changed', {
          bubbles: true,
          detail: {
            items: this.getCartItems(),
          },
        })
      );
    }

    getCartItems() {
      return Array.from(this.selectedItems.values()).map((item) => ({
        id: item.id,
        quantity: item.quantity,
      }));
    }

    clearSelections() {
      this.selectedItems.clear();
      this.renderSelections();
    }

    showMessage(message) {
      if (!this.statusMessage) return;

      this.statusMessage.textContent = message;
      this.statusMessage.hidden = false;
    }
  }

  customElements.define('birthstone-addon', BirthstoneAddon);
}